import { useTranslation } from 'react-i18next'
import { HiOutlineClock } from 'react-icons/hi2'

interface SessionTimeoutModalProps {
  countdown: number
  onContinue: () => void
  onLogout: () => void
}

export function SessionTimeoutModal({ countdown, onContinue, onLogout }: SessionTimeoutModalProps) {
  const { t } = useTranslation('common')

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center p-6"
      role="dialog"
      aria-modal="true"
      aria-labelledby="session-timeout-title"
    >
      <div className="absolute inset-0 bg-black/50" />
      <div className="relative z-[1] flex w-[min(100%,24rem)] flex-col items-center gap-4 rounded-lg bg-white px-7 py-8 text-center shadow-[0_1.5rem_3rem_rgba(13,26,48,0.22)]">
        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[#fff4e5] text-[#e67e22]">
          <HiOutlineClock size={32} />
        </div>
        <h2 className="m-0 text-[1.125rem] font-bold text-text-primary" id="session-timeout-title">
          {t('sessionTimeout.title')}
        </h2>
        <p className="m-0 text-[0.875rem] leading-[1.5] text-text-muted">
          {t('sessionTimeout.message', { seconds: countdown })}
        </p>
        <div className="min-w-12 text-[2.5rem] font-extrabold leading-none text-[#e67e22]">{countdown}</div>
        <div className="mt-2 flex w-full flex-col gap-[0.625rem]">
          <button
            type="button"
            className="w-full cursor-pointer rounded-md bg-brand-primary px-4 py-3 text-[0.9375rem] font-semibold text-white [transition:opacity_0.15s_ease] hover:opacity-[0.88]"
            onClick={onContinue}
          >
            {t('sessionTimeout.continue')}
          </button>
          <button
            type="button"
            className="w-full cursor-pointer rounded-md border border-border-soft bg-transparent px-4 py-3 text-[0.9375rem] font-semibold text-text-muted [transition:opacity_0.15s_ease] hover:opacity-[0.88]"
            onClick={onLogout}
          >
            {t('sessionTimeout.logout')}
          </button>
        </div>
      </div>
    </div>
  )
}
